import React, {useRef, useState, useEffect, Fragment} from 'react'
import pdfTronViewer from '@pdftron/webviewer'
import { getInstance } from '@pdftron/webviewer'

// Material-UI Core
import {withStyles, makeStyles, useTheme} from '@material-ui/core/styles'

// Custom Style
import webViewerStyle from '../../styles/jss/components/webViewer/webViewerStyle'

// Global Function


const useStyles = makeStyles(theme => webViewerStyle(theme))

const WebViewer = props => {
	const {property, readOnly=false, zoom=false, move, ocr=false, closeDoc=false} = props
	const classes = useStyles()
	const store = require('store')
	const viewerDiv = useRef(null)
	

	useEffect(() => {
		pdfTronViewer({
			path: process.env.REACT_APP_PDFTRON_PATH,
			licenseKey: process.env.REACT_APP_PDFTRON_LICENSE_KEY,
			fullAPI: true,
			// initialDoc: 'https://pdftron.s3.amazonaws.com/downloads/pl/webviewer-demo.pdf'
		}, viewerDiv.current).then(instance => {
			const {docViewer, Annotations, annotManager} = instance

			if (readOnly) {
				// instance.disableElements(['ribbons'])
				instance.disableElements(['toolbarGroup-Shapes'])
				instance.disableElements(['toolbarGroup-Edit'])
				instance.disableElements(['toolbarGroup-Insert'])
				instance.disableElements(['toolbarGroup-Annotate'])
				instance.setToolbarGroup('toolbarGroup-View')
			}

			if (ocr) {
				const ocrButton = {
					type: 'toolButton',
					toolName: 'AnnotationCreateRectangle',
				}

				instance.updateTool('AnnotationCreateRectangle', {
					buttonName: "OcrRectangle",
					buttonImage: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.com/svgjs" version="1.1" width="24" height="24" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><g xmlns="http://www.w3.org/2000/svg"><path d="m319.675 265.086c12.789 0 24.507-4.902 32.863-14.866 3.549-4.232 2.995-10.539-1.236-14.088-4.232-3.549-10.54-2.996-14.088 1.236-4.467 5.328-10.528 7.718-17.538 7.718-16.543 0-30.001-13.458-30.001-29.999s13.458-29.999 30.001-29.999c6.013 0 11.811 1.77 16.766 5.118 4.577 3.092 10.792 1.889 13.885-2.688 3.092-4.576 1.889-10.792-2.688-13.884-8.276-5.59-17.945-8.545-27.964-8.545-27.571 0-50.002 22.429-50.002 49.999s22.431 49.998 50.002 49.998z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m382.877 265.086c5.523 0 10-4.477 10-10v-22.645l25.747 29.252c3.65 4.147 9.971 4.547 14.114.9 4.147-3.649 4.549-9.968.9-14.114l-20.332-23.1c13.185-3.798 22.826-15.583 22.826-29.5 0-16.978-14.341-30.791-31.969-30.791h-21.26c-.004 0-.009.001-.013.001s-.009-.001-.013-.001c-5.523 0-10 4.477-10 10v79.999c0 5.523 4.477 9.999 10 9.999zm21.286-79.998c6.488 0 11.968 4.942 11.968 10.791s-5.481 10.791-11.968 10.791c-2.61 0-7.035.018-11.167.038-.057-11.207-.022-7.353-.062-21.62z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m257.673 215.087c0-27.57-22.431-49.999-50.002-49.999s-50.002 22.429-50.002 49.999 22.431 49.999 50.002 49.999 50.002-22.429 50.002-49.999zm-80.003 0c0-16.542 13.459-29.999 30.001-29.999s30.001 13.458 30.001 29.999-13.458 29.999-30.001 29.999-30.001-13.457-30.001-29.999z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m481.999 215.087c0-102.058-83.035-185.088-185.099-185.088s-185.098 83.03-185.098 185.088c0 30.925 7.635 60.096 21.102 85.746l-121.028 121.022c-15.835 15.833-15.835 41.595 0 57.428l20.814 20.814c15.871 15.869 41.56 15.872 57.431 0l121.029-121.022c25.651 13.466 54.824 21.101 85.75 21.101 102.064 0 185.099-83.03 185.099-185.089zm-185.099-155.088c85.521 0 155.098 69.572 155.098 155.089s-69.577 155.089-155.098 155.089-155.097-69.572-155.097-155.089c.001-85.517 69.576-155.089 155.097-155.089zm-227.993 418.885c-4.147 4.146-10.857 4.146-15.003 0l-20.814-20.813c-4.146-4.146-4.147-10.856 0-15.003l116.307-116.3c10.252 13.506 22.312 25.565 35.818 35.817z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m496.999 0h-73.423c-8.284 0-15.001 6.716-15.001 15s6.716 15 15.001 15h58.422v58.419c0 8.284 6.716 15 15.001 15s15.001-6.717 15.001-15.001v-73.418c0-8.284-6.716-15-15.001-15z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m96.802 103.418c8.284 0 15.001-6.716 15.001-15v-58.419h58.422c8.284 0 15.001-6.716 15.001-15s-6.716-15-15.001-15h-73.423c-8.284 0-15.001 6.716-15.001 15v73.419c0 8.284 6.716 15 15.001 15z" fill="#868e96" data-original="#000000" style="" class=""/><path d="m496.999 326.757c-8.284 0-15.001 6.716-15.001 15v58.419h-58.422c-8.284 0-15.001 6.716-15.001 15s6.716 15 15.001 15h73.423c8.284 0 15.001-6.716 15.001-15v-73.419c0-8.285-6.716-15-15.001-15z" fill="#868e96" data-original="#000000" style="" class=""/></g></g></svg>',
					tooltip: "OCR"
				})

				docViewer.getTool('AnnotationCreateRectangle').setStyles(currentStyle => ({
					StrokeThickness: 1,
					StrokeColor: new Annotations.Color(0, 153, 51),
					FillColor: new Annotations.Color(0, 153, 51, 0.1),
					// TextColor: new Annotations.Color(0, 0, 0),
					// FontSize: '20pt'
				}))

				instance.setHeaderItems(header => {
					const items = header.getItems()

					items.splice(9, 0, 
						ocrButton,
						{
							type: 'divider'
						}
					)
				})

				annotManager.on('annotationChanged', (annotations, action) => {
					if (action === 'add') {
						annotations.map(annotation => {
							const coordinate = annotation.getRect()
							console.log("coordinate : ", coordinate)
						})
					}

					annotManager.deleteAnnotations(annotations)
				})
			}

			docViewer.on('documentLoaded', () => {
				let zoomValue = 0
				let x = 0
				let y = 0

				if (typeof zoom == 'number') {
					zoomValue = zoom /100
				}
				else {
					zoomValue = 1
				}

				if (move) {
					x = move.x
					y = move.y

					docViewer.zoomTo(zoomValue, x, y)	
				}
				else {
					docViewer.zoomTo(zoomValue)
				}
			})

			if (property) {
				if (property.from === "API") {
					instance.loadDocument(
						`${process.env.REACT_APP_API_URL_3002}/file/download?file_cat=${property.file_cat}&file_ref=${property.file_ref}`, {
							filename: property.file_name,
			
							customHeaders: {
								"Authorization": "Bearer " + store.get('access_token'),
								"site": store.get('site'),
								"locale": store.get('locale')
							}
						}
					)
				}
				else if (property.from === "FILE_OBJECT") {
					instance.loadDocument(
						property.file,
						{
							filename: property.file.name
						}
					)
				}
			}
		})
	}, [])


	useEffect(() => {
		const instance = getInstance(viewerDiv.current)

		if (property) {
			if (!property.autoLoading) {
				if (property.from === "API") {
					if (instance) {
						instance.loadDocument(
							`${process.env.REACT_APP_API_URL_3002}/file/download?file_cat=${property.file_cat}&file_ref=${property.file_ref}`, {
								filename: property.file_name,
				
								customHeaders: {
									"Authorization": "Bearer " + store.get('access_token'),
									"site": store.get('site'),
									"locale": store.get('locale')
								}
							}
						)
					}
				}
				else if (property.from === "FILE_OBJECT") {
					if (instance) {
						instance.loadDocument(
							property.file,
							{
								filename: property.file.name
							}
						)
					}
				}
			}
		}
	}, [property])

	
	useEffect(() => {
		const instance = getInstance(viewerDiv.current)

		if (closeDoc) {
			instance.closeDocument().then(() => {
				console.log('Document closed')
			})
		}
	}, [closeDoc])


	return (
		<Fragment>
			<div ref={viewerDiv} className={classes.webViewer}></div>
		</Fragment>
	)
}

export default WebViewer